<template> 
  <section 
    class="video-container" 
    ref="videoContainer"
  >   
  <div class="video__container">
      <div class="title" data-animate="fadeIn">{{ fields['Title section'] }}</div>
      <div class="desc" data-animate="fadeIn">{{ fields['Text section'] }}</div>
      <video 
        ref="video" 
        preload="metadata"
        muted 
        playsinline
        :src="`${this.$store.state.base_directory}${fields['Video'].replace(/^public\//, '')}`"
      >
        <!-- <source :src="`${this.$store.state.base_directory}${fields['Video'].replace(/^public\//, '')}`" type="video/mp4" /> -->
      </video>
  </div>
  </section>
</template>

<script>
export default {
props: {
  fields: [Array,Object],
},
data() {
  return {
    videoDuration: 0, // Продолжительность видео в секундах
    scrollRatio: 0.002, // Пониженное соотношение для более плавной перемотки
    lastScrollTop: 0, // Для отслеживания изменений прокрутки
  };
},
mounted() {
  const video = this.$refs.video;
  video.onloadedmetadata = () => {
    this.videoDuration = video.duration;
    this.setBlockHeight();
    window.addEventListener('scroll', this.onScroll);
  };
},
beforeUnmount() {
  window.removeEventListener('scroll', this.onScroll);
},
methods: {
  setBlockHeight() {
    const container = this.$refs.videoContainer;
    container.style.height = `${(this.videoDuration / this.scrollRatio) + 600}px`;
  },
  onScroll() {
    if (!this.$refs.videoContainer || !this.$refs.video) return;

    const container = this.$refs.videoContainer;
    const scrollTop = window.scrollY - container.offsetTop;

    if (Math.abs(scrollTop - this.lastScrollTop) >= 1) { 
      this.lastScrollTop = scrollTop;
      const newTime = (scrollTop * this.scrollRatio); 
      this.$refs.video.currentTime = Math.min(newTime, this.videoDuration);
    }
  },
}
};
</script>


<style scoped>
.video__container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 66px;
  position: sticky;
  height: 100vh;
  justify-content: center;
}
.video-container {

  width: 100%;
  height: 100vh;
  background: rgb(38, 52, 80);
  height: 100vh;

}
.video-container .title{
color: rgb(255, 255, 255);
font-size: 44px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: center;
padding-bottom: 24px;
}
.video-container .desc{
color: rgb(255, 255, 255);
font-size: 24px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: center;
max-width: 771px;
padding-bottom: 73px;
}
video {
  width: 100%;
  height: 482px;
  object-fit: cover;
}
@media (max-width: 1024px) {
  .video-container .title{
    font-size: 32px;
  }
  .video-container .desc{
    font-size: 22px;
  }
}
@media (max-width: 768px) {
  .video-container{
    background: unset;
  }
  .video__container{
    height: 70vh;
  }
  .video-container .title{
  font-size: 24px;
  padding-bottom: 24px;
  color: black;
  }
  .video-container .desc{
  font-size: 18px;
  padding-bottom: 24px;
  color: black;
  }
  video {
    width: 100%;
    height: 409px;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
